var React = require('react');

function Icons8CollapseArrow (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M16 6.594l-.719.688-12.5 12.5 1.438 1.438L16 9.438l11.781 11.781 1.438-1.437-12.5-12.5z","fill":"#fff"}));
}

Icons8CollapseArrow.defaultProps = {"viewBox":"0 0 32 32","fill":"#000000","xmlnsV":"https://vecta.io/nano"};

module.exports = Icons8CollapseArrow;

Icons8CollapseArrow.default = Icons8CollapseArrow;
